import {IProjectDetails} from "./Project";

export default class Profile {
    id: string = '';
    name:string = '';
    initials: string = '';
    username: string = '';
    projects: Array<IProjectDetails> = [];
}
